import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'demo-form-controls',
    templateUrl: './demo-form-controls.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoFormControlsComponent implements OnInit {
    form!: FormGroup;
    searchValue: string | null = null;
    isReadonly = false;
    isDisabled = false;

    errorMessages: Record<string, string> = {
        required: 'This field is required',
        minlength: 'Minimum 3 characters',
        email: 'Invalid email format',
    };

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            textField: new FormControl('', [Validators.required, Validators.minLength(3)]),
            emailField: new FormControl('', [Validators.email]),
            passwordField: new FormControl(''),
            numberField: new FormControl(''),
            textareaField: new FormControl('', [Validators.required]),
        });
    }

    toggleReadonly() {
        this.isReadonly = !this.isReadonly;
        this.change.markForCheck();
    }

    toggleDisabled() {
        this.isDisabled = !this.isDisabled;
        if (this.isDisabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
        this.change.markForCheck();
    }

    markAllTouched() {
        Object.values(this.form.controls).forEach(c => {
            c.markAsTouched();
            c.markAsDirty();
        });
        this.change.markForCheck();
    }

    resetForm() {
        this.form.reset();
        this.change.markForCheck();
    }

    onSearchChanged(value: string | null) {
        this.searchValue = value;
        this.change.markForCheck();
    }
}
